import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredOneElementRules } from '../../../../../../../../../../constants/forms/validation/rules'
import { useGetMaterialGroupsQuery } from '../../../../../../../../../../store/api/material-groups-api'

interface materialGroupsProps {}

const MaterialGroups: FC<materialGroupsProps> = () => {
    const { data } = useGetMaterialGroupsQuery()

    return (
        <Form.Item name={'materialGroups'} label={'Виды матерала'} rules={requiredOneElementRules}>
            <Select
                options={data?.data.map(item => ({ value: item.documentId, label: item.name }))}
                mode={'multiple'}
            />
        </Form.Item>
    )
}

export default MaterialGroups
